/**
 * validateEmail Helper Function
 *
 * Validates email address format using regex pattern.
 *
 * @param email - The email string to validate
 * @returns boolean - true if valid, false otherwise
 */
export const validateEmail = (email: string) => {
  // Email regex: local@domain.extension format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
};
